import Loader from "../Loader";
import "./style.css";

const HexSpinnerLoader = ({ className }) => {
  return (
    <div className={`hex-spinner-loader ${className || ""}`}>
      <Loader />
    </div>
  );
};

export default HexSpinnerLoader;
